import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material/';
import React, { useEffect, useState } from 'react';
import Review from '../Review/Review';


const Reviews = () => {
    // useState for reviews 
    const [reviews, setReviews] = useState([]);

    // useEffect for products 
    useEffect(() => {
        fetch('https://warm-oasis-84574.herokuapp.com/reviews')
            .then(res => res.json())
            .then(data => setReviews(data));
    }, [])
    return (


        <Box sx={{ flexGrow: 1, mt: 5 }} style={{ paddingBottom: '100px' }}>
            <Container>
                <Typography variant="h1" className="heading" style={{ fontFamily: 'Raleway', pb: 0, fontSize: "2.5rem" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                    gutterBottom>

                    <span>H</span>
                    <span>A</span>
                    <span>P</span>
                    <span>P</span>
                    <span>Y</span>
                    <span className="space">{""}</span>
                    <span>S</span>
                    <span>T</span>
                    <span>U</span>
                    <span>D</span>
                    <span>E</span>
                    <span>N</span>
                    <span>T</span>
                    <span>S </span>


                </Typography>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingTop: "30px" }}>
                    {reviews.map(review =>
                        <Review
                            key={review.name}
                            review={review}
                        ></Review>
                    )}
                </Grid>
            </Container>
        </Box>

    );
};

export default Reviews;